import { graphql } from 'react-relay/legacy.js';
import { type homepageRootQuery$variables } from './__generated__/homepageRootQuery.graphql.ts';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $fetchInitialHomepage: Boolean!
        $userType: String!
        $abTestList: [String] = []
        $userCountryCode: String!
        $isTrade: Boolean!
        $priceBookName: String!
        $isClient: Boolean!
        $shouldSkipShopByModule: Boolean!
        $isRemoveTopHeroBannerTestVariant: Boolean!
        $isEvergreenCollectionsTestVariant: Boolean!
        $isNewArrivalsCarouselTabsTestVariant: Boolean!
        $isHpMixedGridTestVariant: Boolean!
        $isRemoveCuratedContentTestVariant: Boolean!
    ) {
        viewer {
            ...HpSharedLayout_viewer
            ...isEmptyHomePage_viewer
            ...getHomePageMetaContent_viewer
        }
    }
`;

const homepageVariables: homepageRootQuery$variables = {
    fetchInitialHomepage: true,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    isClient: false,
    userType: '',
    isTrade: false,
    userCountryCode: '',
    priceBookName: 'DEFAULT',
    isRemoveTopHeroBannerTestVariant: false,
    isEvergreenCollectionsTestVariant: false,
    isNewArrivalsCarouselTabsTestVariant: false,
    isHpMixedGridTestVariant: false,
    isRemoveCuratedContentTestVariant: false,
    shouldSkipShopByModule: false,
};

export { homepageRootQuery, homepageVariables };
